module.exports = __webpack_public_path__ + "img/19.b4cb2f15.jpg";